// extracted by mini-css-extract-plugin
module.exports = {"main":"bankLand_main__kylj0","useBalance":"bankLand_useBalance__2KhuQ","selected":"bankLand_selected__1oRkx","info":"bankLand_info__2nIvr"};